export default __webpack_public_path__ + "static/media/web.7b9a1e5d.png";